import { render, staticRenderFns } from "./SelectedResponsibles.vue?vue&type=template&id=f974aa7e&scoped=true&"
import script from "./SelectedResponsibles.vue?vue&type=script&lang=js&"
export * from "./SelectedResponsibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f974aa7e",
  null
  
)

export default component.exports